import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import Collections from "../../../../../components/Collections";

const breadcrumbsStatic = [
	{
		name:'Financials',
		url: '/financial',
		icon:'dashboard'
	},
	{
	name: 'Audit Work Orders',
	url: '/financial/audit_work_orders',
	icon: 'book',
}];

class AuditWorkOrders extends Framework.Components.View {
	render() {
		return(
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}/>
				<Collections.AuditWorkOrders />
			</div>
		)
	}
}

export default Framework.Components.withRootState(AuditWorkOrders);
